import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useForgotPassword } from '../hooks/useForgotPassword';
import { useLanguageContext } from '../hooks/useLanguageContext';
import translations from '../translations';
import './Signup.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [logoSrc, setLogoSrc] = useState('/wpk-logo.svg');
  const { forgotPassword, error, message, isLoading } = useForgotPassword();
  const [searchParams] = useSearchParams();
  const { language, setLanguage } = useLanguageContext();

  const t = translations[language] || translations.nl;

  useEffect(() => {
    const referrer = searchParams.get('ref');
    if (referrer === 'wpk') {
      setLogoSrc('/wpk-logo.svg');
    } else if (referrer === 'pvangeest') {
      setLogoSrc('/p-van-geest-plantenkwekerij-logo_100px.png');
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ref = searchParams.get('ref') || 'pvangeest';
    await forgotPassword(email.toLowerCase(), ref, language);
  };

  return (
    <div className="signup-container">
      <form className="signup-form" onSubmit={handleSubmit}>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
          <select
            className="language-select"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
          >
            <option value="nl">Nederlands</option>
            <option value="en">English</option>
            <option value="de">Deutsch</option>
            <option value="fr">Français</option>
          </select>
        </div>

        <div className="logo-container">
          <img src={logoSrc} alt="Logo" className="logo" />
        </div>

        <h3>{t.forgotPasswordPage.title}</h3>
        <p>{t.forgotPasswordPage.intro}</p>

        <label>{t.email}:</label>
        <input
          type="email"
          placeholder="info@bedrijf.com"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          required
          className="input-field"
        />

        <button disabled={isLoading} className="submit-button">
          {t.forgotPasswordPage.button}
        </button>

        {message && (
          <div style={{ marginTop: '10px', color: '#2e7d32', fontSize: '0.9rem' }}>
            {message}
          </div>
        )}

        {error && <div className="error-message">{error}</div>}

        <div style={{ marginTop: '16px', fontSize: '0.9rem' }}>
          <Link to={`/login?ref=${searchParams.get('ref')}`}>
            {t.forgotPasswordPage.backToLogin}
          </Link>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;